module.exports = __webpack_public_path__ + "images/questions/qa_logo_7cadb3322609abcbc5a920e1a9dcf1a1.png";